import { render, staticRenderFns } from "./AddTerminalModal.vue?vue&type=template&id=60474fd7&"
import script from "./AddTerminalModal.vue?vue&type=script&lang=js&"
export * from "./AddTerminalModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTerminalModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports